import React, { useState } from 'react'
import IconButton from '@/components/Button/IconButton'
import Checkbox from '@/components/Checkbox'
import Input from '@/components/Input'
import { searchIcon } from '@/images'
import { GxForm, GxIcon } from '@garpix/garpix-web-components-react'
import style from '../styles/champ.module.scss'
import SelectGame from '@/components/Select/SelectGame'
import { TypeLoadData } from '@/interfaces/Fetcher'
import SelectAge from '@/components/Select/SelectAge'

interface IProps {
  handleFilter: TypeLoadData
  initFilters: any
}

const Filters = ({ handleFilter, initFilters }: IProps): React.ReactElement => {
  const [filter, setFilter] = useState({
    q: undefined,
    version: undefined,
    age_group: undefined,
    status: 'open',
    page_size: initFilters.page_size
  })

  const handleVersionChange = (e): void => {
    const newFiltres = { ...filter, version: e.target.value }
    setFilter(newFiltres)
    handleFilter(1, newFiltres)
  }

  const handleAgeGroupChange = (e): void => {
    const newFiltres = { ...filter, age_group: e.target.value }
    setFilter(newFiltres)
    handleFilter(1, newFiltres)
  }

  const handleStatus = (e): void => {
    const checked = e.target.checked
    const newFiltres = { ...filter, status: checked === true ? 'open' : '' }
    setFilter(newFiltres)
    handleFilter(1, newFiltres)
  }

  const inputSearch = (e): void => setFilter({ ...filter, q: e.target.value })

  const onSubmit = (): void => handleFilter(1, filter)
  return (
    <GxForm onGx-submit={onSubmit}>
      <div className={style.filters}>
        <Input
          onGx-input={inputSearch}
          type='text'
          theme='secondary'
          placeholder='Поиск...'
          className={style.filters_search}
        >
          <IconButton
            type='submit'
            theme='red'
            size='medium'
            slot='suffix'
            className={style.filters_search__button}
          >
            <GxIcon src={searchIcon} className={style.filters_search__icon} />
          </IconButton>
        </Input>

        <SelectGame
          clearable
          onGx-change={handleVersionChange}
          theme='secondary'
          className={style.filters_block}
        />

        <SelectAge
          clearable
          onGx-change={handleAgeGroupChange}
          theme='secondary'
          className={style.filters_block}
        />

        <Checkbox
          onGx-change={handleStatus}
          theme='secondary'
          className={style.filters_block}
          checked={filter.status === 'open'}
        >
          Активные чемпионаты
        </Checkbox>
      </div>
    </GxForm>
  )
}

export default Filters
